var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiquidBottleIcon = function SvgLiquidBottleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 142,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.35 11.83v45.336l14.844 13.118 7.03 18.504-2.39 19.644-11.262 16.284-17.559 9.193H40.18l-17.558-9.193-11.267-16.284-2.39-19.644L16 70.284l14.844-13.118V11.831",
    fill: "url(#liquid-bottle-icon_svg__a)",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.35 11.83v45.336l14.844 13.118 7.03 18.504-2.39 19.644-11.262 16.284-17.559 9.193H40.18l-17.558-9.193-11.267-16.284-2.39-19.644L16 70.284l14.844-13.118V11.831",
    stroke: "url(#liquid-bottle-icon_svg__b)",
    strokeOpacity: 0.2,
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.186 11.83h53.822",
    stroke: "url(#liquid-bottle-icon_svg__c)",
    strokeOpacity: 0.4,
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.262 47.973-1.605-1.597v-26.46l1.605-1.602 1.6 1.601v26.461l-1.6 1.597Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.167 17.317H55.83v36.605h7.337V17.317Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.952 76.544 27 79.811l1.545-8.442 7.952-3.262-1.545 8.437ZM73.714 97.285l5.296 6.603-9.616 13.91-10.189 5.312-1.715-2.21 7.814-6.799 8.41-16.816Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "liquid-bottle-icon_svg__a",
    x1: -9,
    y1: 75,
    x2: 107,
    y2: 139.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "liquid-bottle-icon_svg__b",
    x1: -16,
    y1: 51,
    x2: 130,
    y2: 136.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "liquid-bottle-icon_svg__c",
    x1: 24.201,
    y1: 12.831,
    x2: 81.704,
    y2: 12.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })))));
};
export default SvgLiquidBottleIcon;